import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-f965b-schedule-b-audit',
    templateUrl: './f965b-schedule-b-audit.component.html',
    styleUrls: ['./f965b-schedule-b-audit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class F965BScheduleBAuditComponent implements OnInit {

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  filterParams: any = {};
  rowData: any = {};
  baseURLs: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  showFormLoader = true;
  private isInitialized = false;
  batchRows: any[] = [];
  transactionRows: any[] = [];
  filteredTransactions: any[] = [];
  batchColumns: string[] = [];
  transactionColumns: string[] = [];
  selectedBatchKey: any = null;

  @Input('filter-params')
  set _filter_params(v: string) {
    try {
      const params = safeJsonInput<any>(v, null, 'f965b-schedule-b-audit.parse1');
      if (params && Object.keys(params).length > 0) {
        this.filterParams = params;
        this.tryInit();
      }
    } catch (e) {
      console.log('Filter params input not yet stable.');
    }
  }

  @Input('base-urls')
  set _base_urls(v: string) {
    try {
      const urls = safeJsonInput<any>(v, null, 'f965b-schedule-b-audit.parse2');
      if (urls && Object.keys(urls).length > 0) {
        this.baseURLs = urls;
        this.tryInit();
      }
    } catch (e) {
      console.log('Base URLs input not yet stable.');
    }
  }

  @Input('header-data')
  set _header_data(v: string) {
    try {
      const header = safeJsonInput<any>(v, null, 'f965b-schedule-b-audit.parse3');
      if (header && Object.keys(header).length > 0) {
        this.globalService = header.globalParams;
        this.GENERAL_CONFIG = header.generalConfigData;
        this.tryInit();
      }
    } catch (e) {
      console.log('Header data input not yet stable.');
    }
  }

  @Input('row-data')
  set _row_data(v: string) {
    try {
      const data = safeJsonInput<any>(v, null, 'f965b-schedule-b-audit.parse4');
      if (data && Object.keys(data).length > 0) {
        this.rowData = data;
        this.tryInit();
      }
    } catch (e) {
      console.log('Row data input not yet stable.');
    }
  }

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {}

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.globalService || !this.GENERAL_CONFIG) return;
    this.isInitialized = true;
    this.batchRows = this.rowData?.batchRows || this.rowData?.BATCH_ROWS || this.rowData?.batchData || [];
    this.transactionRows = this.rowData?.transactionRows || this.rowData?.TRANSACTION_ROWS || this.rowData?.transactionData || [];
    this.filteredTransactions = [...this.transactionRows];
    this.batchColumns = this.batchRows.length > 0 ? Object.keys(this.batchRows[0]) : [];
    this.transactionColumns = this.transactionRows.length > 0 ? Object.keys(this.transactionRows[0]) : [];
    this.showFormLoader = false;
    this.cdr.detectChanges();
  }

  viewTransactions(batch: any): void {
    this.selectedBatchKey = batch?.BATCH_ID || batch?.batch_id || batch?.ID || null;
    const batchKey = batch?.BATCH_ID || batch?.batch_id || batch?.ID;
    if (!batchKey) {
      this.filteredTransactions = [...this.transactionRows];
    } else {
      this.filteredTransactions = this.transactionRows.filter((item: any) => {
        return item?.BATCH_ID === batchKey || item?.batch_id === batchKey || item?.ID === batchKey;
      });
    }
    this.cdr.detectChanges();
  }
}
